import { useNavigate, useParams } from 'react-router-dom'
import { ALL_INTEGRATIONS } from '@super/shared-types'
import { IntegrationConnector } from '@/components/integrations/IntegrationConnector'

export function IntegrationConnectorStep() {
  const navigate = useNavigate()
  const { type } = useParams<{ type: string }>()

  const backToList = () => navigate('/onboarding/integrations')

  // Route param is the registry's URL slug (e.g. 'rent-manager',
  // 'property-meld'). Look the entry up by URL so hyphens don't get folded
  // into underscores when we resolve to the canonical TYPE.
  const entry = type
    ? ALL_INTEGRATIONS.find(i => i.URL === type.toLowerCase())
    : null

  if (!entry) {
    backToList()
    return null
  }

  return (
    <IntegrationConnector
      type={entry.TYPE}
      mode="onboarding"
      onConnected={backToList}
      onCancel={backToList}
    />
  )
}
